export default __webpack_public_path__ + "static/spark_app_mail_list-3343c51293c13b2a94853fea8e65330c.png";